var map = {
	"./black/lixianrenwu.png": "BJOZ",
	"./blue/lixianrenwu.png": "H89S",
	"./white/lixianrenwu.png": "I4rf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aLW8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/lixianrenwu\.png$
// module id = aLW8
// module chunks = 24